import { useState } from "react";
import { Task, NotificationTaskType } from "services/tasks";
import { Notification, deleteNotifications } from "services/notifications";
import { TaskListItem } from "./components/TaskListItem";
import { NotificationListItem } from "./components/NotificationListItem";
import { useTranslation } from "react-i18next";
import "./NotificationsList.css";

interface NotificationListProps {
  tasks: Task[];
  notifications: Notification[];
  closeDetails: () => void;
  refresh: () => void;
}

export default function NotificationsList({
  tasks,
  notifications,
  closeDetails,
  refresh,
}: NotificationListProps) {
  const { t } = useTranslation();
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteAllNotifications = () => {
    setIsDeleting(true);
    deleteNotifications(
      { notifications: notifications.map(({ id }) => id) },
      () => {
        refresh();
      },
      () => {
        refresh();
      }
    );
  };
  const items =
    tasks.length === 0 && notifications.length === 0 ? (
      <div className="notification-list-item">
        {t("Common.pageHeader.notificationsEmptyState")}
      </div>
    ) : (
      [
        ...tasks.map((item, index) => {
          if (
            item.type === NotificationTaskType.FEEDBACK ||
            item.type === NotificationTaskType.PLAN
          ) {
            return <TaskListItem key={index} item={item} closeDetails={closeDetails} />;
          } else {
            return null;
          }
        }),
        ...notifications.map(notification => (
          <NotificationListItem
            key={notification.id}
            item={notification}
            closeDetails={closeDetails}
            refresh={refresh}
          />
        )),
      ]
    );

  return (
    <>
      {notifications.length > 1 && (
        <div className="notifications-clear-all">
          <button onClick={deleteAllNotifications} disabled={isDeleting}>
            {t("Common.pageHeader.clearAll")}
          </button>
        </div>
      )}
      <div className="notifications-list">{items}</div>
    </>
  );
}
